import React, { useState } from "react";

const JSONNode = ({ data, name, defaultExpanded }) => {
    const [expanded, setExpanded] = useState(defaultExpanded !== undefined ? defaultExpanded : false);

    const toggle = () => setExpanded(!expanded);
    const isObject = typeof data === "object" && data !== null;

    return (
        <div style={{ marginLeft: "16px" }}>
            <div
                style={{ cursor: isObject ? "pointer" : "default", fontWeight: isObject ? "bold" : "normal" }}
                onClick={isObject ? toggle : undefined}
            >
                {name}:{" "}
                {!isObject ?
                    (
                        typeof data === "number" ?
                            <span style={{ color: "#555" }}>{data.toFixed(1)}</span>
                            :
                            <span style={{ color: "#555" }}>{String(data)}</span>
                    )
                    : expanded ? (
                        "▼"
                    ) : (
                        "▶"
                    )}
            </div>
            {isObject && expanded && (
                <div style={{ marginLeft: "16px" }}>
                    {Object.entries(data).map(([key, value]) => (
                        <JSONNode key={key} name={key} data={value} defaultExpanded={false} />
                    ))}
                </div>
            )}
        </div>
    );
};

const JSONViewer = ({ data }) => {
    return (
        <div
            style={{
                background: "#f4f4f4",
                padding: "10px",
                borderRadius: "8px",
                fontFamily: "monospace",
                fontSize: "14px",
            }}
        >
            <JSONNode name="root" data={data} defaultExpanded={true} />
        </div>
    );
};

export default JSONViewer;
